import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BreadCrumb } from '@nationwide/internet-servicing-angular-components';
import { PersonalConstants } from 'app/common/personalConstants';
import { ROUTING } from 'app/common/routeConstants';
import { ClaimsHelperService } from 'app/shared/services/claims-helper.service';
import { LoggerService } from 'app/shared/services/logger.service';
import { SessionService } from 'app/shared/services/session.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'is-claim-details',
  templateUrl: './claim-details.component.html',
  styleUrls: ['./claim-details.component.scss'],
  standalone: false
})
export class ClaimDetailsComponent implements OnInit {
    breadCrumbs: BreadCrumb[];
    claimNumber: string;
    currentPage: string;
    fromMFA: string;
    incidentDate: string;
    homeIconLink = environment.NATIONWIDE.REGISTERED_LOGO_URL;
    isUnregisteredUser: boolean = false;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private logger: LoggerService,
        private sessionService: SessionService,
        private claimsHelperService: ClaimsHelperService
    ) {}

    ngOnInit(): void {
        this.isUnregisteredUser = this.sessionService.getUserType() && this.sessionService.getUserType().indexOf('unregistered') >= 0;
        this.currentPage = this.route.snapshot.data['title'];
        this.fromMFA = this.sessionService.getSessionItemDecrypted('fromMFA');
        this.incidentDate = this.sessionService.getSessionItemDecrypted('incidentDate');
        this.claimNumber = this.claimsHelperService.getClaimId();

        this.logger.setComponentName(`Claim details - ${this.currentPage}`);

        this.setBreadCrumbs();
    }

    setBreadCrumbs(): void {
        if (this.fromMFA === 'true') {
            this.homeIconLink = ROUTING.PROPERTY.BASE_PATH + ROUTING.PROPERTY.CHILD_PATH_TRACKER;
            this.breadCrumbs = [];
        } else {
            sessionStorage.setItem('claimType', 'Property');
            this.breadCrumbs = [
                {
                    name: 'Claims',
                    link: `/fileclaim/info${PersonalConstants.CLAIMS_URLS.PROPERTY_CLAIM_LIST_PAGE}`

                },
                {
                    name: 'Claim overview',
                    link: '/property/tracker'
                }
            ];
        }
        if (this.isUnregisteredUser) {
            this.homeIconLink = environment.NATIONWIDE.HOME;
        }
    }

    goBack(): void {
        this.router.navigate(['/property/tracker']);
    }
}
